import { Box, Fab, Typography, useMediaQuery, useTheme } from '@mui/material';

import TAGLink from '@/components/TAGLink';
import TAGSvgIcon, { IconName } from '@/components/TAGSvgIcon';
import { Maybe } from '@/types';

import { TSocialMediaLink, defaultSocialMediaLinks } from './SocialMediaLinks';
import { mobileShareableLinkStyles, mobileShareLinkCompactStyles } from './BlogDetailsPage.styles';
interface ISocialMediaShareLinksProps {
	mediaLinks?: Maybe<TSocialMediaLink[]>;
	isCompactDesign?: Maybe<boolean>;
	iconColor?: Maybe<string>;
	hideIconTitleOnMobile?: Maybe<boolean>;
}

const SocialMediaShareLinks = ({
	mediaLinks,
	isCompactDesign = false,
	iconColor = '',
	hideIconTitleOnMobile = false,
}: ISocialMediaShareLinksProps) => {
	const theme = useTheme();
	const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));
	const shareableLinkPath = (linkUrl: string) => {
		if (globalThis?.location?.href) {
			return linkUrl + globalThis?.location?.href;
		}
		return linkUrl;
	};

	const socialMediaNames = ['Facebook', 'X', 'Threads', 'Reddit', 'LinkedIn', 'Email'];
	const links = mediaLinks ?? defaultSocialMediaLinks;
	const iconColorString: string = iconColor ?? '';

	return (
		<>
			{links.map((link) => {
				const labelId = `shareable_link_label_${link.name}`;
				const hasIcon = socialMediaNames.includes(link.name);
				const showMobileIconTitle = !hideIconTitleOnMobile && hasIcon && isMobileScreen;

				return (
					<TAGLink
						href={shareableLinkPath(link.url)}
						openInNewTab
						noLinkStyle
						key={link.name}
						aria-label={`${link.name} social media link`}
						dataTestId={
							isMobileScreen
								? `shareable_mobile_link_${link.name}`
								: `shareable_desktop_link_${link.name}`
						}
						title={link.name}
					>
						{isCompactDesign ? (
							<Box sx={isMobileScreen ? mobileShareLinkCompactStyles : null}>
								{hasIcon && (
									<TAGSvgIcon
										htmlColor={iconColorString}
										fill={iconColorString}
										icon={link.icon as IconName}
										size={24}
										viewBox="0 0 24 24"
									/>
								)}
							</Box>
						) : (
							<Box sx={isMobileScreen ? mobileShareableLinkStyles : null}>
								<Fab
									size="S"
									variant="alternative"
									data-test-id={
										isMobileScreen
											? `mobile_social_media_button_${link.icon}`
											: `desktop_social_media_button_${link.icon}`
									}
									aria-labelledby={isMobileScreen ? labelId : undefined}
									aria-label={isMobileScreen ? undefined : link.name}
									tabIndex={-1}
								>
									{hasIcon && (
										<TAGSvgIcon
											htmlColor={iconColorString}
											fill={iconColorString}
											icon={link.icon as IconName}
											size={24}
											viewBox="0 0 24 24"
										/>
									)}
								</Fab>
								{(!hasIcon || showMobileIconTitle) && (
									<Typography
										data-test-id={`mobile_shareable_link_text_${link.name}`}
										variant={!hasIcon ? 'bodySmallBook' : 'assistiveText'}
										color="text.primary"
										id={labelId}
									>
										{link.name}
									</Typography>
								)}
							</Box>
						)}
					</TAGLink>
				);
			})}
		</>
	);
};

export default SocialMediaShareLinks;
